import * as React from 'react';
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const StyledTableHead = styled(TableCell)(({ theme }) => ({
  fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%', whiteSpace: "nowrap"
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
  fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%', whiteSpace: "nowrap"
}));

export default function TableDataGrid({ columns, data, isLoading }) {

 

  return (
    <TableContainer sx={{ padding: '10px' }}>
      <Table sx={{ border: '1px solid #E9E9E7', borderRadius: '4px' }}>
        <TableHead>
          <TableRow>
            {columns?.map((col, index) => {
              return (<StyledTableHead

                key={`${col?.name}-${index}`}
              >
                {col?.name}
              </StyledTableHead>)
            }
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (

            <TableRow>
              <StyledTableRow colSpan={columns.length}>

                <CircularProgress sx={{ animationDuration: '2s', color: "#C05222" }} />
              </StyledTableRow>
            </TableRow>
          ) :
            data?.length > 0 ? (
              data?.map((row, index) => (
                <TableRow key={index}>
                  {columns?.map((col, ind) =>

                    <StyledTableRow

                      key={`${col.name}-${ind}`}
                    >
                      {col.renderer ? col.renderer(row) : row[col.field]}
                    </StyledTableRow>

                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableRow colSpan={columns?.length}>
                  Record not found.
                </StyledTableRow>
              </TableRow>
            )}
        </TableBody>
      </Table>
    </TableContainer>

  );
}